import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '@/redux/common/baseQuery';

export interface QueueEntry {
  main_queue_depth: number;
  dlq_depth: number;
  queue_url_configured: boolean;
  dlq_url_configured: boolean;
  worker?: {
    alive?: boolean;
    last_poll_at?: number | null;
  } | null;
}

export interface QueueStatsResponse {
  success: boolean;
  message_code: number;
  data: Record<string, QueueEntry>;
}

export interface DlqActionResponse {
  success: boolean;
  message_code: number;
  data: { redriven?: number; discarded?: number; failed?: number };
}

export const queueAdminApi = createApi({
  reducerPath: 'queueAdminApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['QueueStats'],
  endpoints: (builder) => ({
    getQueueStats: builder.query<QueueStatsResponse, string | void>({
      query: (queue) => ({
        url: '/api/v1/admin/queues/stats',
        params: queue ? { queue } : undefined,
      }),
      providesTags: ['QueueStats'],
    }),

    redriveQueue: builder.mutation<DlqActionResponse, { queue: string; max_messages?: number }>({
      query: ({ queue, max_messages }) => ({
        url: '/api/v1/admin/queues/redrive',
        method: 'POST',
        params: { queue, max_messages },
      }),
      invalidatesTags: ['QueueStats'],
    }),

    discardQueue: builder.mutation<DlqActionResponse, { queue: string; max_messages?: number }>({
      query: ({ queue, max_messages }) => ({
        url: '/api/v1/admin/queues/discard',
        method: 'POST',
        params: { queue, max_messages },
      }),
      invalidatesTags: ['QueueStats'],
    }),
  }),
});

export const {
  useGetQueueStatsQuery,
  useRedriveQueueMutation,
  useDiscardQueueMutation,
} = queueAdminApi;
